import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useGetCoordinates } from '#api/location';
import { IoSearchSharp } from 'react-icons/io5';

import { AddressModal } from '#molecules';
import { KakaoMap } from '#atoms/KakaoMap';

const GymAddAddress = () => {
  const methods = useFormContext();
  const [addressModalOpen, setAddressModalOpen] = useState(false);

  const { data: coordinatesData, isSuccess: coordinatesSuccess } =
    useGetCoordinates(methods.getValues('address'));

  const onAddressComplete = (addressData: { address: string }) => {
    methods.setValue('address', addressData.address);
    setAddressModalOpen(false);
  };

  useEffect(() => {
    if (coordinatesSuccess && coordinatesData) {
      const { x, y } = coordinatesData.documents[0]?.road_address;
      methods.setValue('lat', x);
      methods.setValue('long', y);
    }
  }, [methods.getValues('address'), coordinatesSuccess]);

  return (
    <div className="flex flex-col gap-8 items-start">
      <div className="relative w-full">
        <KakaoMap
          latitude={Number(methods.getValues('lat'))}
          longitude={Number(methods.getValues('long'))}
          MapContainerStyle={{
            border: `1px solid gray`,
            borderRadius: '8px',
            height: '120px'
          }}
        />
        {!methods.getValues('address') ? (
          <div
            onClickCapture={() => setAddressModalOpen(true)}
            className="flex gap-5 justify-center items-center absolute w-full h-full top-0 left-0 backdrop-blur-sm bg-[#18171C]/90 z-1"
          >
            <IoSearchSharp color={'#7750E9'} />
            <p className="text-[#9170F2] font-bold">주소 검색</p>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => setAddressModalOpen(true)}
            className="absolute bottom-5 text-[14px] right-5 z-1 bg-[#18171C] rounded-full px-10 py-4 text-[#EAE8ED]"
          >
            주소 다시 검색
          </button>
        )}
      </div>
      <input
        {...methods.register('address', {
          required: true
        })}
        className="bg-transparent py-10"
        placeholder={'주소를 검색해주세요'}
        disabled
      />
      <input
        {...methods.register('detail')}
        className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
        placeholder={'상세주소를 입력해주세요'}
      />
      {addressModalOpen && (
        <AddressModal
          onComplete={onAddressComplete}
          onCancel={() => {
            setAddressModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default GymAddAddress;
